import React from "react";
import { FaFacebook } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa6";
const Map = () => {
  return (
    <div className="mt-3 w-full sm:w-[50%] mx-[2%] map">
      <div className="rounded-lg shadow-lg p-2 h-[97%] flex flex-col">
        {/* Map section with half height */}
        <div className="relative flex-grow h-[50%] overflow-hidden mb-4">
          <iframe
            className="w-full h-full border-0 rounded-[5px]"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3825.7864740467135!2d80.6858381!3d16.4863462!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a35fbf8589c78e5%3A0x94bcad4ea86f3b16!2sOakya%20IT%20Services%20Private%20Limited!5e0!3m2!1sen!2sin!4v1742552434025!5m2!1sen!2sin"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

        {/* Contact Information */}
        {/* <div className="flex flex-col sm:flex-row justify-between">
          <div className="flex flex-col sm:flex-row">
            <strong>Email: </strong>
            <div className="text-[14px]  ml-1 mt-[.7%]">
              <p>info@siddhiganapathi.com,</p>
              <p>cmd@siddhiganapathi.com</p>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row mt-2 sm:mt-0">
            <strong className="">Mobile: </strong>
            <a href="tel:+919160077777" className="text-[14px] ml-1 mt-[.7%]">
              +91 9160077777, +91 8330077777
            </a>
          </div>

          <div className="flex flex-row sm:flex-row mt-2 sm:mt-0">
            <strong className="flex gap-2">
              <a href="https://www.instagram.com/accounts/login/?next=%2Fsiddhi_ganapathi%2F&source=omni_redirect">
                <FaInstagram className="text-2xl" />{" "}
              </a>{" "}
              <a href="https://www.facebook.com/people/Siddhi-Ganapathi-Developers-Private-Limited/61574220923381/">
                <FaFacebook className="text-2xl" />
              </a>
            </strong>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default Map;
